import store from '@sportson/core-web/state/store';
import Cookies, { COOKIES_CONSTANTS } from '@sportson/core-web/config/cookies';

export default (): string =>
    store.getState().ecommerce.basket.id || Cookies.get(COOKIES_CONSTANTS.ECOMMERCE.BASKET_COOKIE_NAME) || '';
